import React from 'react'
import PropTypes from 'prop-types';
import { Hint, StyledInput, StyledLabel } from "./formStyles";

export const Input = (props) => {
    const {
        autoFocus,
        errors,
        label,
        label: {
            props: {id, className: labelClassNames = ""},
        },
        name,
        onBlur,
        onChange,
        touched,
        type,
        value,
        hint = "",
        ...rest
    } = props;

    return (
        <StyledLabel htmlFor={id} className={`${labelClassNames} ${touched && errors ? "input-error" : ""}`}>
            {label}
            <StyledInput
                type={type}
                name={name}
                onChange={onChange}
                onBlur={onBlur}
                id={id}
                value={value}
                autofocus={autoFocus}
                {...rest}
            />
            {!!hint && <Hint>{hint}</Hint>}
            {touched && errors && <div className="input-error-message">{errors}</div>}
        </StyledLabel>
    );
};
Input.propTypes = {
  label: PropTypes.shape({
    props: PropTypes.shape({
      id: PropTypes.string.isRequired,
      className: PropTypes.string,
    }),
  }),
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.any,
  touched: PropTypes.bool,
  autoFocus: PropTypes.bool,
  errors: PropTypes.any,
  id: PropTypes.string,
  hint: PropTypes.object,
  rest: PropTypes.any,
}

export default Input



// WEBPACK FOOTER //
// ./src/components/FormElements/Input.js